/*
  Cart +/- moves a shopper between the real bundles instead of adding loose bottles.
  Single + Bundle of 2 + Bundle of 3, with the matching price, Refill schedule and free gifts.
  It wraps window.LyteBitesUpdateCartBundleQuantity (assets/custom.js). The cart's bundle inputs
  step by 1 (snippets/cart-items.liquid); one bundle moves one size up or down, while removing,
  going past Bundle of 3 or several of the same bundle are handed back to the theme's own logic
  in whole-bundle steps.
  Variant, plan and gift ids mirror LyteBitesBundleConfig in assets/custom.js.
*/
(function () {
  var TIERS = {
    1: { variant: '49910584082731', plan: '118709616939', price: 4999 },
    2: { variant: '49910584148267', plan: '118709682475', price: 8999 },
    3: { variant: '49910584181035', plan: '118709715243', price: 11999 }
  };
  var GIFTS = [
    { id: '53368863260971', label: 'Anti-Aging Sleep Strategies Ebook' },
    { id: '53313405518123', label: 'Sleep Strips' },
    { id: '53313406468395', label: 'Anti-Aging Vitamin C Serum' }
  ];
  var busy = false;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Cart update failed'); });
      return r.json();
    });
  }

  function swapBundle(cart, parent, newTier) {
    var oldId = parent.properties._bundle_id || parent.properties._bundle_key;
    var subscribed = !!parent.selling_plan_allocation;
    var removals = {};
    removals[parent.key] = 0;
    cart.items.forEach(function (item) {
      var p = item.properties || {};
      if (item.key !== parent.key && oldId && (p._gift_parent_key === oldId || (p._bundle_id === oldId && p._bundle_role === 'gift'))) {
        removals[item.key] = 0;
      }
    });

    var tier = TIERS[newTier];
    var bundleId = 'lb-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var paid = {
      id: tier.variant,
      quantity: newTier,
      properties: {
        _bundle_type: 'lytebites_subscription',
        _bundle_tier: String(newTier),
        _bundle_quantity: String(newTier),
        _bundle_key: bundleId,
        _bundle_id: bundleId,
        _bundle_role: 'parent',
        _bundle_mode: subscribed ? 'subscription' : 'one_time',
        _quantity_option: String(newTier),
        _custom_total_price: (tier.price / 100).toFixed(2)
      }
    };
    if (subscribed) paid.selling_plan = tier.plan;
    var items = [paid];
    if (subscribed) {
      // Sleep Strips (GIFTS[1]) are sold out: Bundle of 2 and 3 get the Ebook + Vitamin C Serum for now.
      (newTier === 1 ? [GIFTS[0]] : [GIFTS[0], GIFTS[2]]).forEach(function (gift) {
        items.push({
          id: gift.id,
          quantity: 1,
          properties: {
            _free_gift: 'true',
            _bundle_id: bundleId,
            _bundle_role: 'gift',
            _gift_type: 'bundle_subscription_gift',
            _gift_parent_key: bundleId,
            _gift_parent_bundle: String(newTier),
            _gift_label: gift.label
          }
        });
      });
    }

    return post('/cart/update.js', { updates: removals })
      .then(function () { return post('/cart/add.js', { items: items }); })
      .then(function () {
        return typeof window.LyteBitesValidateBundleCart === 'function' ? window.LyteBitesValidateBundleCart() : null;
      })
      .then(function () {
        return typeof window.refreshCartDrawer === 'function' ? window.refreshCartDrawer() : null;
      });
  }

  function install() {
    var original = window.LyteBitesUpdateCartBundleQuantity;
    if (typeof original !== 'function' || original.lbWrapped) return false;

    var wrapped = function (options) {
      var requested = parseInt(options && options.quantity, 10) || 0;
      if (busy) return Promise.resolve(false);
      return fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var parent = (cart.items || []).find(function (item) {
            if (options.lineItemKey) return item.key === options.lineItemKey;
            return item.properties && item.properties._bundle_id === options.bundleId && item.properties._bundle_role === 'parent';
          });
          var p = parent && parent.properties || {};
          var tier = parseInt(p._bundle_tier, 10) || 0;
          if (!parent || p._bundle_role !== 'parent' || !tier || requested <= 0) return original(options);
          var current = parent.quantity;
          var up = requested > current;
          var newTier = 0;
          if (current === tier) {
            // One bundle: step to the next / previous bundle size.
            if (up && tier < 3) newTier = tier + 1;
            else if (!up && tier > 1) newTier = tier - 1;
            else if (up) return original(Object.assign({}, options, { quantity: current + tier }));
            else return Promise.resolve(false);
          } else {
            // Several of the same bundle: add or remove one whole bundle, as the theme expects.
            return original(Object.assign({}, options, { quantity: up ? current + tier : Math.max(tier, current - tier) }));
          }
          busy = true;
          return swapBundle(cart, parent, newTier).finally(function () { busy = false; });
        });
    };
    wrapped.lbWrapped = true;
    window.LyteBitesUpdateCartBundleQuantity = wrapped;
    return true;
  }

  // custom.js defines the function on DOMContentLoaded, so keep trying briefly until it exists.
  var tries = 0;
  (function wait() {
    if (install() || ++tries > 50) return;
    setTimeout(wait, 100);
  })();
})();
